
import { useSelector } from 'react-redux';

import { getApp } from '../reducers';
import { getUserPermissions } from '../reducers/app';

export default function useUserPermissionsState() {
    return useSelector(state => getUserPermissions(getApp(state)));
}
